// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"6a771aa8","498":"07cab65b","703":"17f3f2a0"}[chunkId] + ".chunk.js";
};